import { FC, ReactNode } from "react";

export const LvlFilterBox: FC<{
  text: string;
  children: ReactNode;
}> = ({ text, children }) => {
  return (
    <div className="mb-10 flex items-center justify-between">
      <div className="text-base font-normal text-[#5E6D77]">{text}</div>
      <div>{children}</div>
    </div>
  );
};
